<template>
  <div>
    <div v-if="this.ram.progress != null">
       <h5 style="line-height:0.1; margin-top: 18px; margin-bottom: -10px; font-size: 15px;" :class="ram.progress_color_text">{{ ram.progress }} % &nbsp;&nbsp;&nbsp;&nbsp;{{ ram.used }} / {{ ram.total }}</h5>
        <vs-progress :percent="ram.progress" :color="ram.progress_color">primary</vs-progress>
    </div>
    <div v-else>
      <!-- <h5 style="line-height:1.2; margin-top: 15px;">N/A</h5> -->
      
      <vs-avatar text="N/A" style="margin-top: 10px;"/>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    name: "RamUsageDeviceAgGridComponent",
    data() {
      return {
        ram: {
            progress: null,
            progress_color: 'success',
            progress_color_text: 'text-success',
            progress_info: '',
            used: null,
            total: null,
        },
      }
    },
    methods: {
         readableBytes(bytes) {
                if (bytes > 0){
                    let i = Math.floor(Math.log(bytes) / Math.log(1024)),
                        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                    return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
                }else{
                    return "Unknown"
                }

            }
    },
    mounted() {
        if (this.params.data.hasOwnProperty('system_info')) {
            if (this.params.data.system_info.hasOwnProperty('total_ram') && this.params.data.system_info.hasOwnProperty('free_ram')) {
                if (this.params.data.system_info.total_ram!=="N/A" && this.params.data.system_info.free_ram!=="N/A") {
                    let free_ram = parseFloat(this.params.data.system_info.free_ram)
                    let total_ram = parseFloat(this.params.data.system_info.total_ram)
                    let used_ram = total_ram - free_ram
                    let result = (used_ram/total_ram) * 100
                    this.ram.progress = parseFloat(result.toFixed(2))
                    this.ram.used = this.readableBytes(used_ram)
                    this.ram.total = this.readableBytes(total_ram)
                    if (this.ram.progress > 85) {
                        this.ram.progress_color = 'danger'
                        this.ram.progress_color_text = 'text-danger'
                    } else if (this.ram.progress>=70 && this.ram.progress <= 85 ) {
                        this.ram.progress_color = 'warning'
                        this.ram.progress_color_text = 'text-warning'
                    } else {
                        this.ram.progress_color = 'success'
                         this.ram.progress_color_text = 'text-success'
                    }
                } else {
                    this.ram.progress = null
                }
            } else {
                this.ram.progress = null
            }                
        } else {
            this.ram.progress = null
        }
       
    }
        
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 10%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .line-0 {
    line-height: 0;
  }
</style>